import { AdyenCheckout } from '@adyen/adyen-web';

export async function handle3DS2Redirect(action, adyenSettings) {
  const adyenCheckout = await AdyenCheckout({
    clientKey: adyenSettings['clientKey'],
    countryCode: 'DE',
    environment: adyenSettings['environment'],
  });

  adyenCheckout.createFromAction(action).mount(document.body);
}
